<template>
	<div class="forms-view">
		<main-section-forms></main-section-forms>
	</div>
</template>

<script>
	import FormsView from "@/components/main-section-forms.vue";

	export default {
		components: {
			"main-section-forms": FormsView,
		},
	};
</script>

<style scoped>
	/* Add your scoped styles here */
</style>
